/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBookingInfoDto } from './order-booking-info-dto';
import {
    OrderBookingInfoDtoFromJSON,
    OrderBookingInfoDtoFromJSONTyped,
    OrderBookingInfoDtoToJSON,
    OrderBookingInfoDtoToJSONTyped,
} from './order-booking-info-dto';
import type { SubmitPersonalInfoRequestDto } from './submit-personal-info-request-dto';
import {
    SubmitPersonalInfoRequestDtoFromJSON,
    SubmitPersonalInfoRequestDtoFromJSONTyped,
    SubmitPersonalInfoRequestDtoToJSON,
    SubmitPersonalInfoRequestDtoToJSONTyped,
} from './submit-personal-info-request-dto';
import type { OrderSystemInfoDto } from './order-system-info-dto';
import {
    OrderSystemInfoDtoFromJSON,
    OrderSystemInfoDtoFromJSONTyped,
    OrderSystemInfoDtoToJSON,
    OrderSystemInfoDtoToJSONTyped,
} from './order-system-info-dto';

/**
 * 
 * @export
 * @interface CreateNewBookingRequest
 */
export interface CreateNewBookingRequest {
    /**
     * Список кодов размещения (типов номеров/условий размещения)
     * @type {Array<string>}
     * @memberof CreateNewBookingRequest
     */
    placementCodes: Array<string>;
    /**
     * Idempotency key to ensure the same request isn't processed twice
     * @type {string}
     * @memberof CreateNewBookingRequest
     */
    idempKey: string;
    /**
     * 
     * @type {SubmitPersonalInfoRequestDto}
     * @memberof CreateNewBookingRequest
     */
    persons: SubmitPersonalInfoRequestDto;
    /**
     * 
     * @type {OrderSystemInfoDto}
     * @memberof CreateNewBookingRequest
     */
    systemInfo: OrderSystemInfoDto;
    /**
     * 
     * @type {OrderBookingInfoDto}
     * @memberof CreateNewBookingRequest
     */
    bookingInfo: OrderBookingInfoDto;
}

/**
 * Check if a given object implements the CreateNewBookingRequest interface.
 */
export function instanceOfCreateNewBookingRequest(value: object): value is CreateNewBookingRequest {
    if (!('placementCodes' in value) || value['placementCodes'] === undefined) return false;
    if (!('idempKey' in value) || value['idempKey'] === undefined) return false;
    if (!('persons' in value) || value['persons'] === undefined) return false;
    if (!('systemInfo' in value) || value['systemInfo'] === undefined) return false;
    if (!('bookingInfo' in value) || value['bookingInfo'] === undefined) return false;
    return true;
}

export function CreateNewBookingRequestFromJSON(json: any): CreateNewBookingRequest {
    return CreateNewBookingRequestFromJSONTyped(json, false);
}

export function CreateNewBookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNewBookingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'placementCodes': json['placementCodes'],
        'idempKey': json['idempKey'],
        'persons': SubmitPersonalInfoRequestDtoFromJSON(json['persons']),
        'systemInfo': OrderSystemInfoDtoFromJSON(json['systemInfo']),
        'bookingInfo': OrderBookingInfoDtoFromJSON(json['bookingInfo']),
    };
}

  export function CreateNewBookingRequestToJSON(json: any): CreateNewBookingRequest {
      return CreateNewBookingRequestToJSONTyped(json, false);
  }

  export function CreateNewBookingRequestToJSONTyped(value?: CreateNewBookingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'placementCodes': value['placementCodes'],
        'idempKey': value['idempKey'],
        'persons': SubmitPersonalInfoRequestDtoToJSON(value['persons']),
        'systemInfo': OrderSystemInfoDtoToJSON(value['systemInfo']),
        'bookingInfo': OrderBookingInfoDtoToJSON(value['bookingInfo']),
    };
}

